import Vue from 'vue'

export default {
  mapExclusionCriteria (formData) {
    let path = `${process.vars.BACKEND_HOST}/api/ui/maintenance/option_ids/map_exclusion_criteria`
    let requestBody = {
      from_assignment_term_id: formData['fromAssignmentTermId'],
      to_assignment_term_ids: this.transformArray(formData['toAssignmentTermIds'].split(','))
    }
    return Vue.http.post(path, requestBody)
  },

  updateAnswersOfProduct (formData) {
    let path = `${process.vars.BACKEND_HOST}/api/ui/maintenance/option_ids/update_answers_of_product`
    let requestBody = {
      product_id: formData['productId'],
      add_answer_uuids: this.transformArray(this.preventEmptyValues(formData['addAnswerUuids'])),
      remove_answer_uuids: this.transformArray(this.preventEmptyValues(formData['removeAnswerUuids']))
    }
    return Vue.http.post(path, requestBody)
  },

  updateAnswersOfVendor (formData) {
    let path = `${process.vars.BACKEND_HOST}/api/ui/maintenance/option_ids/update_answers_of_vendor`
    let requestBody = {
      vendor_id: formData['vendorId'],
      product_id: formData['productId'],
      add_answer_uuids: this.transformArray(this.preventEmptyValues(formData['addAnswerUuids'])),
      remove_answer_uuids: this.transformArray(this.preventEmptyValues(formData['removeAnswerUuids']))
    }
    return Vue.http.post(path, requestBody)
  },

  updateAnswersOfAssignmentTerms (formData) {
    let path = `${process.vars.BACKEND_HOST}/api/ui/maintenance/option_ids/update_answers_of_assignment_terms`
    let requestBody = {
      product_id: formData['productId'],
      add_answer_uuids: formData['addAnswerUuids'].split(','),
      remove_answer_uuids: formData['removeAnswerUuids'].split(','),
      assignment_term_ids: this.transformArray(formData['assignmentTermIds'].split(','))
    }
    return Vue.http.post(path, requestBody)
  },

  transformArray (array) {
    let modifiedArray = array.map(function (item) {
      return item.replace(/\s/g, '')
    })
    return modifiedArray
  },

  preventEmptyValues (string) {
    if (string == null) {
      return []
    }
    return string.split(',')
  }
}
